import React from 'react'
import { INFTCreateStepStatus } from './INFTCreateModal'
import { ReactComponent as Check } from '../../../../assets/images/check.svg'
import { ReactComponent as Error } from '../../../../assets/images/x.svg'
import styled from 'styled-components'
import Circle from '../../../../assets/images/blue-loader.svg'
import { CustomLightSpinner } from '../../../../theme'

const NFTCreateStepStatusWrapper = styled.div`
  width: 30px;
  height: 30px;

  svg {
    width: inherit;
    height: inherit;

    &.none {
      fill: ${({ theme }) => theme.bg6};
      opacity: 0.5;
    }

    &.error {
      fill: ${({ theme }) => theme.red1};
    }

    &.success {
      fill: ${({ theme }) => theme.green1};
    }
  }
`

export default function NFTCreateStepStatus({ status }: INFTCreateStepStatus) {
  function getStatusIcon() {
    let result = <Check className={status} />
    if (status === 'error') {
      result = <Error className={status} />
    } else if (status === 'pending') {
      result = <CustomLightSpinner src={Circle} alt="loader" size={'30px'} />
    }
    return result
  }
  return <NFTCreateStepStatusWrapper>{getStatusIcon()}</NFTCreateStepStatusWrapper>
}
